(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["14-merch-cartel-about-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-editorial-about')) {
    customElements.define('mc-editorial-about', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.cleanup();
      }

      init() {
        if (!this.isConnected) return;
        this.cleanup();
        this.dataset.motionReady = 'true';
        this.items = Array.from(this.querySelectorAll('[data-motion]'));
        this.parallaxItems = Array.from(this.querySelectorAll('[data-parallax]'));
        this.animations = new Map();
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.addEventListener('click', (event) => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || this.reduced.matches) return;
          const target = document.getElementById(link.getAttribute('href').slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
        }, { signal });

        const enabled = this.dataset.motionEnabled === 'true'
          && !this.reduced.matches
          && 'IntersectionObserver' in window
          && !(window.Shopify && window.Shopify.designMode);

        if (!enabled) {
          this.showAll();
          return;
        }

        try {
          this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this.reveal(entry.target);
              this.observer.unobserve(entry.target);
            }
          }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

          for (const item of this.items) {
            delete item.dataset.revealed;
            if (item.getBoundingClientRect().bottom < 0) {
              this.reveal(item, false);
              continue;
            }
            this.target(item).style.opacity = '0';
            this.observer.observe(item);
          }
          this.classList.remove('mc-story--pending');

          this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.showAll(); }, { signal });
          this.addEventListener('focusin', (event) => {
            const item = event.target.closest('[data-motion]');
            if (!item) return;
            const animation = this.animations.get(item);
            if (animation) animation.cancel();
            this.reveal(item, false);
          }, { signal });
          window.addEventListener('pageshow', (event) => { if (event.persisted) this.showAll(); }, { signal });

          if (this.parallaxItems.length) {
            const schedule = () => {
              if (this.frame == null) this.frame = requestAnimationFrame(() => this.parallax());
            };
            window.addEventListener('scroll', schedule, { passive: true, signal });
            window.addEventListener('resize', schedule, { passive: true, signal });
            schedule();
          }
        } catch (error) {
          this.showAll();
        }
      }

      target(item) {
        return item.dataset.motion === 'line' && item.firstElementChild ? item.firstElementChild : item;
      }

      reveal(item, animate = true) {
        if (item.dataset.revealed === 'true') return;
        item.dataset.revealed = 'true';
        const target = this.target(item);
        target.style.opacity = '';
        if (!animate || this.reduced.matches || typeof target.animate !== 'function') return;

        const presets = {
          rise: { frames: [{ opacity: 0, transform: 'translate3d(0, 28px, 0)' }, { opacity: 1, transform: 'none' }], duration: 800 },
          line: { frames: [{ transform: 'translate3d(0, 110%, 0)' }, { transform: 'translate3d(0, 0, 0)' }], duration: 1000 },
          image: { frames: [{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0 0)' }], duration: 1150 },
        };
        const preset = presets[item.dataset.motion] || presets.rise;
        const animation = target.animate(preset.frames, {
          duration: preset.duration,
          delay: Math.min(Number(item.dataset.delay) || 0, 320),
          easing: 'cubic-bezier(.22, 1, .36, 1)',
          fill: 'backwards',
        });
        this.animations.set(item, animation);
        animation.finished.then(() => this.animations.delete(item)).catch(() => {});
      }

      showAll() {
        if (this.observer) this.observer.disconnect();
        if (this.animations) {
          this.animations.forEach((animation) => animation.cancel());
          this.animations.clear();
        }
        for (const item of this.items || []) {
          item.dataset.revealed = 'true';
          item.style.opacity = '';
          if (item.dataset.motion === 'line' && item.firstElementChild) item.firstElementChild.style.opacity = '';
        }
        for (const item of this.parallaxItems || []) item.style.transform = '';
        this.classList.remove('mc-story--pending');
      }

      parallax() {
        this.frame = null;
        const active = this.desktop.matches && !this.reduced.matches;
        for (const item of this.parallaxItems) {
          if (!active) {
            item.style.transform = '';
            continue;
          }
          const bounds = item.parentElement.getBoundingClientRect();
          if (bounds.bottom < 0 || bounds.top > window.innerHeight) continue;
          const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - bounds.top - bounds.height / 2) / window.innerHeight));
          item.style.transform = 'translate3d(0, ' + (progress * 20).toFixed(2) + 'px, 0)';
        }
      }

      cleanup() {
        if (this.observer) this.observer.disconnect();
        if (this.abort) this.abort.abort();
        if (this.animations) this.animations.forEach((animation) => animation.cancel());
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
